import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissingBom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_624_71",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_624_71)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.048 19.1173L16.923 21.227L15.8693 20.173L17.979 18.048L15.8693 15.923L16.923 14.8693L19.048 16.979L21.173 14.8693L22.227 15.923L20.1173 18.048L22.227 20.173L21.173 21.227L19.048 19.1173ZM6 21.5C5.30133 21.5 4.71 21.258 4.226 20.774C3.742 20.29 3.5 19.6987 3.5 19V16.1155H6.5V2.5H20.5V12.3365C20.2602 12.2583 20.0152 12.2013 19.7652 12.1655C19.5152 12.1295 19.2602 12.1115 19 12.1115V4H8V16.1155H13.4365C13.352 16.3552 13.2853 16.5984 13.2365 16.8453C13.1878 17.0919 13.1571 17.3486 13.1443 17.6152H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20H13.4365C13.5313 20.2872 13.6515 20.5542 13.797 20.801C13.9425 21.0477 14.1069 21.2807 14.2902 21.5H6ZM9.19225 8.69225V7.19225H17.8077V8.69225H9.19225ZM9.19225 11.577V10.077H17.8077V11.577H9.19225ZM13.4365 20H5H13.1443H13.123H13.4365Z",
			fill: "currentColor"
		})
	})]
});
export default SvgMissingBom;
